import mixpanel from 'mixpanel-browser'

import { MixpanelMock } from '@lyrahealth-inc/shared-app-logic/src/testing/moduleMocks/mixpanel/mixpanelMock'

declare global {
  interface Window {
    Cypress: any
    mixpanelMock: MixpanelMock
    spyTrack: any
  }
}
const mixpanelMock = new MixpanelMock('mockToken')

if (window.Cypress) {
  window.mixpanelMock = mixpanelMock
  window.spyTrack = window.Cypress.cy.spy(mixpanelMock, 'track')
  window.Cypress.log({ message: 'Now spying on Mixpanel track calls' })
}
const Mixpanel = window.Cypress ? mixpanelMock : mixpanel
export default Mixpanel
